import * as XLSX from "xlsx"; // Importar la biblioteca SheetJS

const ExcelDownloader = ({ row, fileName }) => {
  const handleDownload = () => {
    let worksheetData;

    if (row.Settings?.cargaManual === true) {
      worksheetData = [
        ["Grupo", "Rut", "Nombre", "Telefono", "Origen", "FechaProgramado", "HoraProgramado", "Destino", "Solicitante", "CentroCosto", "OS", "NG", "Motivo", "Referencia", "Horabus"],
        [
          "1",
          "12345678-9",
          "NOMBRE APELLIDO",
          "987654321",
          "DIRECCION NUMERO, COMUNA",
          "2025-01-08",
          "05:45",
          "DIRECCION NUMERO, COMUNA",
          "Nombre Encargado",
          "Segun Convenio",
          "Segun Convenio",
          "Segun Convenio",
          "Segun Convenio",
          "Segun Convenio",
          "Segun Convenio",
        ],
      ];
    } else {
      const baseHeaders = ["Grupo", "Rut", "Nombre", "Telefono", "Origen", "Programado", "Destino"];
      const dynamicHeaders = Object.keys(row.Settings || {}).filter((key) => ["centroCosto", "os", "ng", "motivo"].includes(key));
      const headers = [...baseHeaders, ...dynamicHeaders.map((header) => header.charAt(0).toUpperCase() + header.slice(1))];
      const data = [
        [
          "1",
          "12345678-9",
          "NOMBRE APELLIDO",
          "987654321",
          "GRAN AVENIDA 8363, LA CISTERNA",
          "05:45",
          "DIRECCION NUMERO, COMUNA",
          ...dynamicHeaders.map((key) => (row.Settings[key] ? "SEGUN CONVENIO" : "SEGUN CONVENIO")),
        ],
      ];
      worksheetData = [headers, ...data];
    }

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Formato");

    XLSX.writeFile(workbook, `${fileName || "Formato"}.xlsx`);
  };

  return (
    <button className="btn btn-sm rounded btn-warning" onClick={handleDownload}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-download"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
        <path d="M7 11l5 5l5 -5" />
        <path d="M12 4l0 12" />
      </svg>{" "}
      Formato
    </button>
  );
};

export default ExcelDownloader;
